import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  Button as MatButton,
  Divider,
  Tooltip,
  IconButton,
  Grid2,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import PageHeader, {
  BreadcrumbsModel,
} from "../../../../shared/PageHeader/PageHeader";
import PageWrapper from "../../../../shared/PageWrapper/PageWrapper";
import Button from "../../../../components/Button/Button";
import { useEffect, useState } from "react";
import { getUser } from "../../../../utils/types";
import moment from "moment";
import ConfirmationDialog from "../../../../components/ConfirmationDialog/ConfirmationDialog";
import AutoRescheduleDialog from "../../../../shared/AutoReschedule/AutoRescheduleDialog";
import API from "../../../../api/axios";
import { useDispatch } from "react-redux";
import { setToast } from "../../../../store/slices/toastSlice";
import DataLoader from "../../../../shared/DataLoader/DataLoader";
import HandleInterviewLink, { handleDate } from "../../../../shared/CommonFunctions/CommonFunction";

const breadcrumbs: BreadcrumbsModel[] = [
  { name: "Candidate Management", route: "/admin/candidate-management" },
  { name: "Reschedule Interview" },
];

const CandidateManageMentRescheduleInterview = () => {
  const navigate = useNavigate();
  const loggedUserdata = getUser();
  const [selectByDate, setSelectByDate] = useState<any>();
  const [isRescheduleDialogOpen, setIsRescheduleDialogOpen] = useState(false);
  const [isRescheduleloading, setIsRescheduleloading] = useState(false);
  const [interviewerInfo, setInterviewerInfo] = useState<any>({});
  const [dataLoading, setDataLoading] = useState<boolean>(false);
  const [resetForm, setResetForm] = useState(false);
  const [rescheduleData, setRescheduleData] = useState<any>([]);
  const [rescheduleDataLoding, setRescheduleDataLoading] =
    useState<boolean>(false);
  const [autoReschedleTimeExceeds, setAutoRescheduleTimeExceeds] =
    useState<boolean>(false);
  const [interviewCompleted, setInterviewCompleted] = useState<boolean>(false);
  const state = useLocation();
  const dispatch = useDispatch();

  const getInterviewData = async () => {
    setDataLoading(true);
    try {
      let response = await API.post("/positions/all/applied", {
        offset: 0,
        limit: -1,
        applicationID: state?.state?.reschduleData?.application_id?.id,
      });
      setInterviewerInfo(response?.data?.data[0]);
    } catch (error) {
      // Failed to fetch interview view data
    } finally {
      setDataLoading(false);
    }
  };

  useEffect(() => {
    getInterviewData();
  }, [state]);

  const checkInterviewerName = (interviewers: any) => {
    const hasValidInterviewer = interviewers?.some(
      (interviewer: any) =>
        interviewer?.interviewer_name !== null &&
        interviewer?.interviewer_name !== undefined
    );

    return hasValidInterviewer
      ? interviewers?.map((val: any, index: number) => {
          return <Box>{`${index + 1}. ${val?.interviewer_name || "NA"}`}</Box>;
        })
      : "NA";
  };

  const handleRescheduleConfirm = async (data?: any, reset?: () => {}) => {
    setIsRescheduleloading(true);
    try {
      let response = await API.post("/reschedule/interview/request", {
        application_id: state?.state?.reschduleData?.application_id?.id,
        schedule_id: state?.state?.reschduleData?.id,
        reason: data?.reason,
      });
      if (response?.statusText == "OK" || response?.status == 200) {
        dispatch(
          setToast({
            message: response?.data?.message,
            severity: "success",
            open: true,
          })
        );
        setResetForm(true);
        setIsRescheduleDialogOpen(false);
        getLatestRescheduleRequest();
      }
    } catch (error) {
      // Auto reschedule request failed; loading and dialog state are still finalized
    } finally {
      setIsRescheduleloading(false);
    }
  };

  const handleRescheduleClick = (data: any) => {
    setIsRescheduleDialogOpen(true);
  };

  const handleRescheduleCancel = () => {
    setIsRescheduleDialogOpen(false);
  };

  const formatTime = (startTime: any, endTime: any) => {
    if (startTime === "NA") {
      return "NA";
    }

    return `${moment(startTime, "HH:mm:ss").format("hh:mm A")} - ${moment(
      endTime,
      "HH:mm:ss"
    ).format("hh:mm A")}`;
  };

  function isTimeWithinTenMinutes(passedDate: any, passedTime: any) {
    const passedDateTime = passedDate + " " + passedTime;
    const passedMoment = moment(passedDateTime, "YYYY-MM-DD HH:mm:ss");
    const currentMoment = moment();
    const differenceInMinutes = passedMoment.diff(currentMoment, "minutes");
    if (passedMoment.isBefore(currentMoment)) {
      setInterviewCompleted(true);
      return true;
    }
    return differenceInMinutes <= 10;
  }

  const getLatestRescheduleRequest = async () => {
    setRescheduleDataLoading(true);
    try {
      if (interviewerInfo?.scheduled_applications?.length > 0) {
        let response = await API.get(
          `/items/interview_reschedule_requests?fields=*&filter[status]=published&sort[]=-id&limit=1&filter[application_id]=${interviewerInfo?.id}&filter[reshedule_status]=pending&filter[schedule_id]=${interviewerInfo?.scheduled_applications[0]?.id}`
        );
        setRescheduleData(response?.data?.data);
      }
    } catch (err) {
      // Failed to fetch latest reschedule request
    } finally {
      setRescheduleDataLoading(false);
    }
  };

  useEffect(() => {
    getLatestRescheduleRequest();
    if (interviewerInfo?.scheduled_applications?.length > 0) {
      setAutoRescheduleTimeExceeds(
        isTimeWithinTenMinutes(
          interviewerInfo?.scheduled_applications[0]?.slot_date,
          interviewerInfo?.scheduled_applications[0]?.start_time
        )
      );
    }
  }, [interviewerInfo]);

  return (
    <PageWrapper>
      <PageHeader breadcrumbs={breadcrumbs} title="Upcoming Interview">
        <Button
          variant="secondary"
          variantType="contained"
          label="Back"
          onClick={() => {
            if (state?.state?.view === "calender") {
              navigate("/admin/candidate-management/calender-view", {
                ...state?.state,
              });
            } else {
              navigate("/admin/candidate-management/view", { ...state?.state });
            }
          }}
        />
      </PageHeader>
      <Card className="custom__card" sx={{ marginTop: "1.5rem" }}>
        {dataLoading || rescheduleDataLoding ? (
          <Box height={"400px"}>
            <DataLoader />
          </Box>
        ) : (
          <CardContent>
            <Grid2 container spacing={2}>
              <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} marginBottom={4}>
                <Typography variant="body1">Candidate Name</Typography>
                <Typography variant="subtitle2">
                  {interviewerInfo?.candidate_name || "NA"}
                </Typography>
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} marginBottom={4}>
                <Typography variant="body1">Email</Typography>
                <Typography
                  variant="subtitle2"
                  sx={{ wordBreak: "break-word" }}
                >
                  {interviewerInfo?.candidate_email || "NA"}
                </Typography>
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} marginBottom={4}>
                <Typography variant="body1">Mobile</Typography>
                <Typography variant="subtitle2">
                  {interviewerInfo?.candidate_mobile || "NA"}
                </Typography>
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} marginBottom={4}>
                <Typography variant="body1">Position Title</Typography>
                <Typography variant="subtitle2">
                  {interviewerInfo?.position_name || "NA"}
                </Typography>
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} marginBottom={4}>
                <Typography variant="body1">Position Status</Typography>
                <Typography variant="subtitle2">
                  {interviewerInfo?.application_display_status || "NA"}
                </Typography>
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} marginBottom={4}>
                <Typography variant="body1">Applied Date</Typography>
                <Typography variant="subtitle2">
                  {!!interviewerInfo?.application_date
                    ?handleDate(interviewerInfo?.application_date)
                    : "NA"}
                </Typography>
              </Grid2>
              {interviewerInfo?.scheduled_applications?.length > 0 && (
                <>
                  <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} marginBottom={4}>
                    <Typography variant="body1">Interview Date</Typography>
                    <Typography variant="subtitle2">
                      {!!interviewerInfo?.scheduled_applications[0]?.slot_date
                        ? handleDate(interviewerInfo?.scheduled_applications[0]
                          ?.slot_date)
                        : "NA"}
                    </Typography>
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} marginBottom={4}>
                    <Typography variant="body1">Interview Time</Typography>
                    <Typography variant="subtitle2">
                      {formatTime(
                        interviewerInfo?.scheduled_applications[0]
                          ?.start_time || "NA",
                        interviewerInfo?.scheduled_applications[0]?.end_time
                      )}
                    </Typography>
                  </Grid2>
                  <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} marginBottom={4}>
                    <Typography variant="body1">Panel Name</Typography>
                    <Typography variant="subtitle2">
                      {checkInterviewerName(
                        interviewerInfo?.scheduled_applications[0]
                          ?.interview_panel
                      )}
                    </Typography>
                  </Grid2>
                </>
              )}
                  {interviewerInfo?.scheduled_applications?.length > 0 && (
                    <>
                    <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }} marginBottom={4}>
                      <Typography variant="body1">Interview Link</Typography>
                      <Typography variant="subtitle2">
                        <HandleInterviewLink link={interviewerInfo?.scheduled_applications?.[0]?.webex_link}/>
                      </Typography>
                    </Grid2>
                    <Grid2
                    size={{ xs: 12, sm: 6, md: 4, lg: 3 }}
                    marginBottom={4}
                  >
                    <Typography variant="body1">Interview Password</Typography>
                    <Typography variant="subtitle2">
                      {interviewerInfo?.scheduled_applications[0]
                        ?.webex_meeting_password || "NA"}
                    </Typography>
                  </Grid2>
                    </>
                  )}
                  <Grid2
                    size={{
                    xs:
                      interviewerInfo?.scheduled_applications?.length > 0
                        ? 6
                        : 12
                    }}
                  >
                    <Typography variant="body1">Description</Typography>
                    <Typography variant="subtitle2">
                      {interviewerInfo?.additional_notes || "NA"}
                    </Typography>
                  </Grid2>
              <Grid2 size={{
                    xs:
                      interviewerInfo?.scheduled_applications?.length > 0
                        ? 6
                        : 12
                    }} marginBottom={4}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography variant="body1">Remarks</Typography>
                    <Typography variant="subtitle2">
                      {interviewerInfo?.issue_notes || "NA"}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid2>
            </Grid2>
            {loggedUserdata?.roles?.role_code !== "administrator" &&
              interviewerInfo?.application_status == "scheduled" &&
              !interviewCompleted && (
                <>
                  <Divider sx={{ marginTop: "30px" }} />

                  <Box sx={{ marginTop: "30px", display: "flex", gap: "20px" }}>
                    <Box sx={{ marginTop: "-10px" }}>
                      <Tooltip
                        title={`${
                          autoReschedleTimeExceeds
                            ? "The interview is scheduled to begin in the next 10 minutes. Rescheduling is no longer possible at this time."
                            : interviewerInfo?.scheduled_applications?.length <=
                              0
                            ? "Interview not scheduled"
                            : rescheduleData?.length > 0
                            ? `A reschedule request for this interview was already generated by an admin on ${moment(
                                rescheduleData[0]?.date_created
                              ).format("DD-MM-YYYY")}`
                            : "Auto Reschedule"
                        }`}
                        arrow
                      >
                        <IconButton>
                          <Button
                            variant="secondary"
                            variantType="contained"
                            label="Auto Reschedule"
                            onClick={() => handleRescheduleClick(state)}
                            disabled={
                              interviewerInfo?.scheduled_applications?.length <=
                                0 || rescheduleData?.length > 0||autoReschedleTimeExceeds
                            }
                          />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </Box>
                  {(interviewerInfo?.scheduled_applications?.length <= 0 ||
                    rescheduleData?.length > 0) && (
                    <Typography
                      variant="subtitle2"
                      sx={{
                        marginTop: "10px",
                        marginLeft: "10px",
                        color: "red",
                        fontSize: "14px",
                        fontWeight: "600",
                      }}
                    >
                      Note :
                      {interviewerInfo?.scheduled_applications?.length <= 0
                        ? " Interview not scheduled"
                        : ` A reschedule request for this interview was already generated by an admin on ${moment(
                            rescheduleData[0]?.date_created
                          ).format("DD-MM-YYYY")}`}{" "}
                    </Typography>
                  )}
                </>
              )}
            <AutoRescheduleDialog
              open={isRescheduleDialogOpen}
              onClose={handleRescheduleCancel}
              onConfirm={handleRescheduleConfirm}
              loading={isRescheduleloading}
              resetForm={resetForm}
            />
          </CardContent>
        )}
      </Card>
    </PageWrapper>
  );
};
export default CandidateManageMentRescheduleInterview;
